module.exports = __webpack_public_path__ + "img/seven6Red.7bc3eaf7.jpg";